import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/checkPermission';
import ButtonActive from 'utils/buttons/ButtonActive';
import ButtonDelete from 'utils/buttons/ButtonDelete';
import ButtonDisable from 'utils/buttons/ButtonDisable';
import ButtonEdit from 'utils/buttons/ButtonEdit';
import ButtonResend from 'utils/buttons/ButtonResend';
import ButtonView from 'utils/buttons/ButtonView';
import ActiveModal from '../../modals/ActiveModal';
import DeleteModal from '../../modals/DeleteModal';
import DisableModal from '../../modals/DisableModal';
import ResendModal from '../../modals/ResendModal';
import { useNavigate } from 'react-router-dom';

export const UsersActions = ({ colab, switchNewUser, setSwitchNewUser }) => {
  const userLogged = useSelector(state => state.login.currentUser);
  const navigate = useNavigate();

  const [userSelected, setUserSelected] = useState({});
  const [usersUpdated, setUsersUpdated] = useState(false);

  //Modals states
  const [deleteModal, setDeleteModal] = useState(false);
  const [disableModal, setDisableModal] = useState(false);
  const [activeModal, setActiveModal] = useState(false);
  const [resendModal, setResendModal] = useState(false);

  //Functions
  const openDeleteModal = ({ id, firstName, lastName }) => {
    setUserSelected({ id, firstName, lastName });
    setDeleteModal(true);
  };

  const openDisableModal = user => {
    setUserSelected(user);
    setDisableModal(true);
  };

  const openActiveUser = user => {
    setUserSelected(user);
    setActiveModal(true);
  };

  const openResendModal = user => {
    setUserSelected(user);
    setResendModal(true);
  };
  useEffect(() => {
    if (switchNewUser) {
      setUsersUpdated(true);
    }
  }, [switchNewUser]);

  useEffect(() => {
    if (usersUpdated) {
      setUsersUpdated(false);
      setSwitchNewUser(false);
    }
  }, [usersUpdated]);

  return (
    <>
      <span className="d-flex gap-2">
        <ButtonView
          funcion={colabId => navigate(`/usuarios/${colabId}`)}
          data={colab.id}
          disabled={!checkPermission('Users', userLogged)}
        />

        <ButtonEdit
          funcion={colabId => navigate(`/usuarios/${colabId}`)}
          data={colab.id}
          disabled={!checkPermission('Edit users', userLogged)}
        />

        {colab.status !== 'disabled' && (
          <ButtonDisable
            funcion={openDisableModal}
            data={colab}
            disabled={!checkPermission('Edit users', userLogged)}
          />
        )}

        {colab.status === 'disabled' && (
          <ButtonActive
            funcion={openActiveUser}
            data={colab}
            disabled={!checkPermission('Edit users', userLogged)}
          />
        )}

        <ButtonResend
          funcion={openResendModal}
          data={colab}
          disabled={
            !(
              colab.status === 'expired' &&
              checkPermission('Create users', userLogged)
            )
          }
        />

        <ButtonDelete
          funcion={openDeleteModal}
          data={colab}
          disabled={
            !(
              colab.status !== 'disabled' &&
              checkPermission('Delete users', userLogged)
            )
          }
        />
      </span>

      {deleteModal && (
        <DeleteModal
          setShow={setDeleteModal}
          user={userSelected}
          switchNewUser={switchNewUser}
          setSwitchNewUser={setSwitchNewUser}
        />
      )}

      {resendModal && (
        <ResendModal
          show={resendModal}
          setShow={setResendModal}
          user={userSelected}
          switchNewUser={switchNewUser}
          setSwitchNewUser={setSwitchNewUser}
        />
      )}
      {activeModal && (
        <ActiveModal
          show={activeModal}
          setShow={setActiveModal}
          user={userSelected}
          switchNewUser={switchNewUser}
          setSwitchNewUser={setSwitchNewUser}
        />
      )}
      {disableModal && (
        <DisableModal
          show={disableModal}
          setShow={setDisableModal}
          user={userSelected}
          switchNewUser={switchNewUser}
          setSwitchNewUser={setSwitchNewUser}
        />
      )}
    </>
  );
};
UsersActions.propTypes = {
  colab: PropTypes.object.isRequired,
  switchNewUser: PropTypes.bool.isRequired,
  setSwitchNewUser: PropTypes.func.isRequired
};
